import React from 'react';
import { Instagram, Mail, Phone, MessageCircle } from 'lucide-react';
import Logo from "../assets/logo.png";

export const Footer = () => {
  return (
    <footer className="bg-secondary text-white py-32 mt-32 noise-overlay">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          <div>
            <img 
              src={Logo} 
              alt="Just Inn Diam" 
              className="h-24 md:h-32 w-auto mb-6"
              style={{color:"#fff"}}
            />
            <p className="text-white/80 leading-relaxed mt-6">
              Premier Diamond Manufacturer serving jewelry brands, designers, and manufacturers worldwide with exceptional quality and craftsmanship.
            </p>
          </div>

          <div>
            <h4 className="font-body uppercase tracking-widest text-sm mb-6 text-primary">Global Offices</h4>
            <ul className="space-y-3 text-white/80">
              <li>India</li>
              <li>USA</li>
              <li>Hong Kong</li>
              <li>Dubai</li>
            </ul>
          </div>

          <div>
            <h4 className="font-body uppercase tracking-widest text-sm mb-6 text-primary">Connect With Us</h4>
            <div className="space-y-4">
              <a href="tel:+918128741058" className="flex items-center gap-3 text-white/80 hover:text-primary transition-colors">
                <Phone size={18} />
                +91 8128741058
              </a>
              <a href="https://wa.me/918128741058?text=Hi%2C%20I%27m%20interested%20in%20your%20diamond%20collection" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-primary transition-colors">
                <MessageCircle size={18} />
                WhatsApp
              </a>
              <a href="mailto:vatsaljasani26@gmail.com" className="flex items-center gap-3 text-white/80 hover:text-primary transition-colors">
                <Mail size={18} />
                vatsaljasani26@gmail.com
              </a>
              <a href="https://instagram.com/mastergem_makers" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-primary transition-colors">
                <Instagram size={18} />
                @mastergem_makers
              </a>
              <a href="https://www.tiktok.com/@justinndiam" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-primary transition-colors">
                <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
                @justinndiam
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center text-white/60 text-sm">
          <p>© {new Date().getFullYear()} Just Inn Diam. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};